import { render, staticRenderFns } from "./PaymentGatewaySettings.vue?vue&type=template&id=1256d940"
import script from "./PaymentGatewaySettings.vue?vue&type=script&lang=js"
export * from "./PaymentGatewaySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports